import { TLegalList } from 'shared/types/legalPages.interface';

export const TermsAndConditionsLists: TLegalList = {
  UserObligations: [
    {
      description: 'Use the Services only for lawful purposes.',
    },
    {
      description: `Not engage in hate speech, harassment, threats, or content that promotes violence, 
        discrimination, or illegal activity.`,
    },
    {
      description: `Not upload, stream, or share content that infringes on the rights of others, including 
        intellectual property rights.`,
    },
    {
      description: 'Not attempt to disrupt, hack, or interfere with the operation of the Services.',
    },
    {
      description: 'Comply with community guidelines and any additional rules we publish.',
    },
  ],
  PlatformRights: [
    {
      description:
        'Suspend, limit, or terminate accounts that violate these Terms or applicable law.',
    },
    {
      description: `Remove or restrict content that we reasonably believe is harmful, unlawful, or violates 
        our policies.`,
    },
    {
      description: 'Modify, suspend, or discontinue any part of the Services at any time.',
    },
  ],
  UserGeneratedContent: [
    {
      description: `You retain ownership of any debates, videos, or materials you create or upload 
        ("User Content").`,
    },
    {
      description: `By using the Services, you grant Deb8.TV LLC a worldwide, non-exclusive, 
        royalty-free license to use, display, stream, store, and distribute your User Content 
        for the purpose of operating and improving the Services.`,
    },
    {
      description: `You are solely responsible for your User Content 
      and the consequences of sharing it.`,
    },
  ],
  DisclaimersAndLimitationsOfLiability: [
    {
      description: `The Services are provided "as is" and "as available." We do not guarantee 
        uninterrupted or error-free operation.`,
    },
    {
      description: `We are not responsible for user-generated content, and we do not endorse any opinions 
        expressed in debates.`,
    },
    {
      description: `To the maximum extent permitted by law, Deb8.TV LLC is not liable for any indirect, 
        incidental, or consequential damages arising from your use of the Services.`,
    },
  ],
};
